import { gql } from "@apollo/client";
import { SelectOption } from "@msys/ui";
import { ROOT_ITEM_ID } from "../../trees-virtual/helpers.js";
import { isAnyParentMatching } from "../../trees/helpers.js";
import { ItemTreeItem } from "../../trees/types.js";
import { getPersonLabel } from "../users/helpers.js";
import { TaskShouldRender_ItemFragment } from "./helpers.generated.js";
import { AssigneeOptions_ProjectFragment } from "./Tasks.generated.js";

export function shouldRenderTaskCreateInput<T extends ItemTreeItem>(
  item: T
): boolean {
  return item.id !== ROOT_ITEM_ID;
}

export function shouldRenderItem<T extends TaskShouldRender_ItemFragment>(
  item: T,
  allItems: T[]
): boolean {
  return (
    item.isTreePreviewItemVisible &&
    !item.isItemEliminated &&
    !item.decisionOptionElimination &&
    !isAnyParentMatching(
      item,
      allItems,
      parentItem =>
        Boolean(parentItem.decisionOptionElimination) ||
        parentItem.isItemEliminated ||
        !item.isTreePreviewItemVisible
    )
  );
}

export function shouldRenderChildItem<T extends TaskShouldRender_ItemFragment>(
  childItem: T
): boolean {
  return (
    childItem.isTreePreviewItemVisible &&
    !childItem.isItemEliminated &&
    !childItem.decisionOptionElimination
  );
}

export const getAssigneeOptions = (
  project: AssigneeOptions_ProjectFragment,
  compact: boolean = false
): SelectOption[] => {
  return project.internalStakeholders
    .filter(s => s.user.membershipStatus === "ACTIVATED")
    .map(s => ({
      label: getPersonLabel(s.user, compact),
      value: s.user.id,
    }))
    .sort((a, b) =>
      a.label.toLocaleLowerCase().localeCompare(b.label.toLocaleLowerCase())
    );
};
